import React, { useState, useEffect } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  Button,
  Flex,
  Checkbox,
  Text,
  Icon
} from "@chakra-ui/react";
import { FaFilter } from "react-icons/fa";
import { LABEL } from "../../../../constants";

const FilterMultiSelectPopover = ({
  label,
  options,
  selectedValues,
  onChange,
  renderOptionLabel = (opt) => (opt.label ?? opt.value ?? opt).toString()
}) => {
  const [tempSelected, setTempSelected] = useState(selectedValues);

  useEffect(() => {
    setTempSelected(selectedValues);
  }, [selectedValues]);

  const toggleOption = (value) => {
    setTempSelected(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };

  const apply = () => {
    onChange(tempSelected);
  };

  const clearAll = () => {
    onChange([]);
  };

  return (
    <Flex align="center">
      <Text>{label}</Text>
      {selectedValues.length > 0 && (
        <Text ml={1} fontSize="sm" color="blue.500">
          ({selectedValues.length})
        </Text>
      )}
      <Popover>
        <PopoverTrigger>
          <Button size="sm" ml="2" variant="ghost">
            <Icon
              as={FaFilter}
              color={selectedValues.length > 0 ? "blue.500" : "gray.500"}
            />
          </Button>
        </PopoverTrigger>

        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>{label}</PopoverHeader>

          <PopoverBody>
            {options.map(opt => {
              const value = opt.value ?? opt;
              return (
                <Flex key={value} align="center" mb={2}>
                  <Checkbox
                    isChecked={tempSelected.includes(value)}
                    onChange={() => toggleOption(value)}
                  >
                    <Text fontSize="sm">{renderOptionLabel(opt)}</Text>
                  </Checkbox>
                </Flex>
              );
            })}
          </PopoverBody>

          <PopoverFooter display="flex" justifyContent="space-between">
            <Button size="sm" onClick={clearAll}>
              {LABEL.DELETE.label}
            </Button>
            <Button size="sm" colorScheme="blue" onClick={apply}>
              {LABEL.APPLY.label}
            </Button>
          </PopoverFooter>
        </PopoverContent>
      </Popover>
    </Flex>
  );
};

export default FilterMultiSelectPopover;
